import React from 'react'
import './VideoEmbed.css'

/**
 * Safe YouTube embed. We never render arbitrary iframe HTML from migrated
 * content; instead we extract the video ID and emit our own locked-down
 * privacy-enhanced (youtube-nocookie) iframe with a fixed allow-list.
 *
 * Supported ID sources (see extractYouTubeId):
 *   - youtube.com/embed/ID, youtube.com/watch?v=ID, youtu.be/ID
 */

// Pull an 11-char YouTube video id out of a URL or raw iframe/embed string.
export function extractYouTubeId(text) {
  if (!text) return null
  const patterns = [
    /youtube(?:-nocookie)?\.com\/embed\/([A-Za-z0-9_-]{11})/i,
    /youtube\.com\/watch\?[^"'\s]*v=([A-Za-z0-9_-]{11})/i,
    /youtu\.be\/([A-Za-z0-9_-]{11})/i,
  ]
  for (const re of patterns) {
    const m = text.match(re)
    if (m) return m[1]
  }
  return null
}

function VideoEmbed({ youtubeId, title = 'Video' }) {
  if (!youtubeId) return null
  return (
    <div className="video-embed">
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${youtubeId}?rel=0`}
        title={title}
        frameBorder="0"
        allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        loading="lazy"
      />
    </div>
  )
}

export default VideoEmbed
